import moment from "moment";
import React from "react";
import { IoLocationSharp } from "react-icons/io5";
import { FaPhoneAlt } from "react-icons/fa";
import { MdEmail } from "react-icons/md";
import { TbWorld } from "react-icons/tb";
import { useSelector } from "react-redux";
import {
  roomCountArrayObject,
  totalRoomsArray,
} from "../../../utils/bookingDetailsHelper";
import { productName, productEdition } from "../../../theme";

const GrcStructure = ({
  bookingDetails,
  paymentDetails,
  customerData,
  val,
}) => {
  const { hotelContentDetails, hotelDetails } = useSelector(
    (store) => store.login
  );
  const { checkInTime, checkOutTime } = hotelDetails;
  const { response } = useSelector((store) => store.rooms);

  let roomTypeString = Object?.keys(bookingDetails?.roomCount)?.join(",");

  const roomCountArray = roomCountArrayObject(bookingDetails, response);
  const roomNoString = totalRoomsArray(roomCountArray)?.join(",");

  const hotelInformation = [
    {
      title: Boolean(hotelDetails && hotelDetails?.name)
        ? hotelDetails?.name
        : null,
      Logo: hotelDetails?.logo,
    },
    {
      title: Boolean(hotelDetails && hotelDetails?.contactNumber)
        ? hotelDetails?.contactNumber
        : null,
      Logo: FaPhoneAlt,
    },
    {
      title1: Boolean(hotelDetails && hotelDetails?.emailAddress)
        ? hotelDetails?.emailAddress
        : null,
      title2: Boolean(hotelDetails && hotelDetails?.website)
        ? hotelDetails?.website
        : null,
      Logo1: MdEmail,
      Logo2: TbWorld,
    },
    {
      title: Boolean(hotelDetails && hotelDetails?.address)
        ? hotelDetails?.address?.substring(0, 150)
        : null,
      Logo: IoLocationSharp,
    },
  ];

  const guestDetailsArray = [
    { title: "Name", value: customerData?.name ?? "-" },
    {
      title: "Contact No",
      value: customerData?.contactDetails?.phoneNumber ?? "-",
    },
    { title: "Email", value: customerData?.email ?? "-" },
    { title: "Address", value: customerData?.address ?? "-" },
    { title: "Gender", value: customerData?.gender?.toUpperCase() ?? "-" },
    {
      title: "DOB",
      value: customerData?.dob
        ? moment(customerData?.dob)?.format("DD MMM YYYY")
        : "-",
    },
  ];

  const checkInDetailsArray = [
    {
      title: "Check-in",
      value: bookingDetails?.checkIn
        ? moment(bookingDetails?.checkIn)?.format("DD MMM YYYY")
        : "-",
    },
    {
      title: "Check-out",
      value: bookingDetails?.checkOut
        ? moment(bookingDetails?.checkOut)?.format("DD MMM YYYY")
        : "-",
    },
    {
      title: "Room Type",
      value: roomTypeString ?? "-",
    },

    {
      title: "Room No",
      value: roomNoString ?? "-",
    },
    { title: "Arrival", value: bookingDetails?.arrival ?? "-" },
    { title: "Destination", value: bookingDetails?.destination ?? "-" },
    {
      title: "Purpose to visit",
      value: bookingDetails?.purposeOfVisit?.toUpperCase() ?? "-",
    },
  ];

  const companyDetailsArray = [
    {
      title: "Name",
      value: customerData?.company ?? "-",
    },
    {
      title: "GSTIN",
      value: customerData?.gstIN ?? "-",
    },
    {
      title: "Designation",
      value: customerData?.designation ?? "-",
    },
  ];

  const foreignDetailsArray = [
    {
      title: "Nationality",
      value: customerData?.nationality ?? "-",
    },
    {
      title: "Pass Validity",
      value: customerData?.gstIn ?? "-",
    },
    {
      title: "Passport No.",
      value: customerData?.passportNumber ?? "-",
    },
    {
      title: "Visa Validity",
      value: customerData?.visaValidity ?? "-",
    },
  ];

  const cancellationPolicyArray = Array.isArray(
    hotelContentDetails?.cancellationPoliciesText
  )
    ? hotelContentDetails?.cancellationPoliciesText?.slice(0, 3)
    : [];

  return (
    <div className={`font-outfit ${val ? "p-9" : "p-2"}`} ref={val}>
      <header className="flex justify-between items-start">
        <div className="flex gap-1 items-start ">
          <div className="font-[700] uppercase text-[16px] leading-[20px] tracking-[1px] text-[#007FFF]">
            Guest Registration <br />
            card
          </div>
        </div>

        <div className="rightSection-PaymentTitleInformation flex flex-col items-end">
          {hotelInformation?.map((Obj, index) => {
            return index === 0 ? (
              <div className=" flex gap-2 items-center">
                <div className="font-outfit text-[#000] font-[600] text-[14px] leading-[21px]">
                  {hotelDetails?.name}
                </div>
              </div>
            ) : index === 2 ? (
              <div className="flex gap-2 items-center" key={Obj.title}>
                {Boolean(Obj?.title1) && (
                  <>
                    {" "}
                    <div className=" text-[#5E6470] font-[400] text-[10px] leading-[15px]">
                      {Obj?.title1}
                    </div>
                    <div className={` bg-[#EBEBEB] rounded-[100%] p-[2px]`}>
                      <Obj.Logo1 className="text-[#5E6470] text-[10px]" />
                    </div>
                  </>
                )}

                {Boolean(Obj?.title2) && (
                  <>
                    {" "}
                    <div className="w-[1px] h-[10px] bg-[#EBEBEB] border-[1px] border-[#EBEBEB]" />
                    <div className=" text-[#5E6470] font-[400] text-[10px] leading-[15px]">
                      {Obj?.title2}
                    </div>
                    <div className={` bg-[#EBEBEB] rounded-[100%] p-[2px]`}>
                      <Obj.Logo2 className="text-[#5E6470] text-[10px]" />
                    </div>
                  </>
                )}
              </div>
            ) : (
              Boolean(Obj?.title) && (
                <div className="flex gap-2 items-center" key={Obj.title}>
                  <div className=" text-[#5E6470] font-[400] text-[10px] leading-[15px]">
                    {Obj?.title}
                  </div>
                  <div className={` bg-[#EBEBEB] rounded-[100%] p-[2px]`}>
                    <Obj.Logo className="text-[#5E6470] text-[10px]" />
                  </div>
                </div>
              )
            );
          })}
        </div>
      </header>

      <div className="flex gap-4 items-center pt-[24px]">
        <div className="font-[600] uppercase whitespace-nowrap text-[12px] leading-[12.16px] text-[#5E6470]">
          Guest Details
        </div>
        <div className="border-[1px] border-[#EBEBEB] w-[100%]" />
      </div>

      <div className="guestDetails w-full flex items-start justify-between pt-[1rem] ">
        <div className="w-[50%] flex flex-col gap-2">
          {guestDetailsArray?.slice(0, 4).map((Obj, index) => (
            <div key={index} className="flex items-start gap-2">
              <span className="font-[400] text-[12px] w-[12ch] whitespace-nowrap leading-[20px] text-[#5E6470]">
                {Obj?.title} :
              </span>

              <span className="text-[#222B45] text-[12px] font-[500] w-[60%] leading-[20px]">
                {Obj?.value}
              </span>
            </div>
          ))}
        </div>

        <div className="w-[50%] flex flex-col gap-2">
          {guestDetailsArray?.slice(4).map((Obj, index) => (
            <div key={index} className="flex items-start gap-2">
              <span className="font-[400] text-[12px] w-[12ch] whitespace-nowrap leading-[20px] text-[#5E6470]">
                {Obj?.title} :
              </span>

              <span className="text-[#222B45] text-[12px] font-[500] w-[60%] leading-[20px]">
                {Obj?.value}
              </span>
            </div>
          ))}
        </div>
      </div>

      <div className="flex gap-4 items-center pt-[24px]">
        <div className="font-[600] uppercase whitespace-nowrap text-[12px] leading-[12.16px] text-[#5E6470]">
          CHECK-IN DETAILS
        </div>
        <div className="border-[1px] border-[#EBEBEB] w-[100%]" />
      </div>

      <div className="checkInDetails w-full flex items-start justify-between pt-[1rem] ">
        <div className="w-[50%] flex flex-col gap-2">
          {checkInDetailsArray?.slice(0, 4).map((Obj, index) => (
            <div key={index} className="flex items-start gap-2">
              <span className="font-[400] text-[12px] w-[12ch] whitespace-nowrap leading-[20px] text-[#5E6470]">
                {Obj?.title} :
              </span>

              <span className="text-[#222B45] capitalize text-[12px] font-[500] w-[60%] leading-[20px]">
                {Obj?.value}
              </span>
            </div>
          ))}
        </div>

        <div className="w-[50%] flex flex-col gap-2">
          {checkInDetailsArray?.slice(4).map((Obj, index) => (
            <div key={index} className="flex items-start gap-2">
              <span className="font-[400] text-[12px] w-[12ch] whitespace-nowrap leading-[20px] text-[#5E6470]">
                {Obj?.title} :
              </span>

              <span className="text-[#222B45] text-[12px] font-[500] w-[60%] leading-[20px]">
                {Obj?.value}
              </span>
            </div>
          ))}
        </div>
      </div>

      <div className="flex gap-4 items-center pt-[24px]">
        <div className="font-[600] uppercase whitespace-nowrap text-[12px] leading-[12.16px] text-[#5E6470]">
          COMPANY DETAILS
        </div>
        <div className="border-[1px] border-[#EBEBEB] w-[100%]" />
      </div>

      <div className="companyDetails w-full flex items-start justify-between pt-[1rem] ">
        <div className="w-[50%] flex flex-col gap-2">
          {companyDetailsArray?.slice(0, 2).map((Obj, index) => (
            <div key={index} className="flex items-center gap-2">
              <span className="font-[400] text-[12px] w-[12ch] whitespace-nowrap leading-[20px] text-[#5E6470]">
                {Obj?.title} :
              </span>

              <span className="text-[#222B45] text-[12px] font-[500] w-[60%] leading-[20px]">
                {Obj?.value}
              </span>
            </div>
          ))}
        </div>

        <div className="w-[50%] flex flex-col gap-2">
          {companyDetailsArray?.slice(2).map((Obj, index) => (
            <div key={index} className="flex items-center gap-2">
              <span className="font-[400] text-[12px] w-[12ch] whitespace-nowrap leading-[20px] text-[#5E6470]">
                {Obj?.title} :
              </span>

              <span className="text-[#222B45] text-[12px] font-[500] w-[60%] leading-[20px]">
                {Obj?.value}
              </span>
            </div>
          ))}
        </div>
      </div>

      <div className="flex gap-4 items-center pt-[24px]">
        <div className="font-[600] uppercase whitespace-nowrap text-[12px] leading-[12.16px] text-[#5E6470]">
          Foreign DETAILS
        </div>
        <div className="border-[1px] border-[#EBEBEB] w-[100%]" />
      </div>

      <div className="forignDetails w-full flex items-start justify-between pt-[1rem] ">
        <div className="w-[50%] flex flex-col gap-2">
          {foreignDetailsArray?.slice(0, 2).map((Obj, index) => (
            <div key={index} className="flex items-center gap-2">
              <span className="font-[400] text-[12px] w-[12ch] whitespace-nowrap leading-[20px] text-[#5E6470]">
                {Obj?.title} :
              </span>

              <span className="text-[#222B45] text-[12px] font-[500] w-[60%] leading-[20px]">
                {Obj?.value}
              </span>
            </div>
          ))}
        </div>

        <div className="w-[50%] flex flex-col gap-2">
          {foreignDetailsArray?.slice(2).map((Obj, index) => (
            <div key={index} className="flex items-center gap-2">
              <span className="font-[400] text-[12px] w-[12ch] whitespace-nowrap leading-[20px] text-[#5E6470]">
                {Obj?.title} :
              </span>

              <span className="text-[#222B45] text-[12px] font-[500] w-[60%] leading-[20px]">
                {Obj?.value}
              </span>
            </div>
          ))}
        </div>
      </div>

      <div className="flex gap-4 items-center pt-[24px]">
        <div className="font-[600] uppercase whitespace-nowrap text-[12px] leading-[12.16px] text-[#5E6470]">
          PAYMENT DETAILS
        </div>
        <div className="border-[1px] border-[#EBEBEB] w-[100%]" />
      </div>

      <div className="paymentDetails w-full flex flex-col gap-2 items-start  pt-[1rem] ">
        {paymentDetails?.map((Obj, index) => (
          <div
            key={index}
            className="flex justify-between items-center gap-2 w-[100%]"
          >
            <div className="font-[400] w-[33%] text-[12px] flex items-center gap-1 leading-[20px] text-[#5E6470]">
              <span className="w-[12ch] ">{index + 1}. Amount :</span>
              <span className="text-[#222B45]">{Obj?.amount}</span>
            </div>

            <div className="text-[#5E6470] flex gap-1 items-center text-[12px] font-[500] w-[33%] leading-[20px]">
              <span className="w-[7ch] ">Mode :</span>
              <span className="text-[#222B45]">{Obj?.method ?? "-"}</span>
            </div>

            <div className="text-[#5E6470] flex gap-1 items-center text-[12px] font-[500] w-[33%] leading-[20px]">
              <span className="w-[14ch] whitespace-nowrap">
                {" "}
                Transaction No :
              </span>
              <span className="text-[#222B45]">
                {Obj?.transactionNo ?? "-"}
              </span>
            </div>
          </div>
        ))}
      </div>

      <div className="idSection mb-[1rem] pb-[1rem] pt-[2rem] right-[5px] flex flex-wrap gap-3">
        {customerData?.idImages?.map((Obj) => {
          return (
            <div className="w-[100px] h-[100px]">
              <img src={Obj} alt="" className="w-[100%] h-[100%]" />
            </div>
          );
        })}
      </div>

      <footer className="mb-[2rem] mt-[1rem]   bottom-0 w-[100%]">
        <div className="w-[100%] flex justify-between items-center pb-[10px]">
          <div className="w-[50%] flex gap-2 items-end">
            <span className="font-[500] text-[12px] leading-[14px] text-[#1A1C21]">
              STAFF SIGNATURE :
            </span>
            <hr className="w-[10rem]  lg:w-[14rem] h-[1px] mt-5 ml-1 bg-gray-300 border-0 rounded" />
          </div>

          <div className="w-[50%] flex gap-2 items-end">
            <span className="font-[500] text-[12px] leading-[14px] text-[#1A1C21]">
              GUEST SIGNATURE :
            </span>
            <hr className="w-[10rem]  lg:w-[14rem] h-[1px] mt-5 ml-1 bg-gray-300 border-0 rounded" />
          </div>
        </div>

        <div className="mb-[5px]">
          <p className="font-outfit text-[#222B45]  font-[400] text-[8px] leading-[13px]">
            <span className="font-[500]"> Disclaimer:</span> Checkin time{" "}
            {checkInTime} & Checkout time {checkOutTime} Noon | T&C Applied
          </p>

          <div className="flex flex-col gap-1">
            {cancellationPolicyArray?.map((Obj) => {
              return (
                <p className="font-outfit font-[500] text-[8px] leading-[13px]">
                  {Obj}
                </p>
              );
            })}
          </div>
        </div>

        <div className="border-[#AEAEAE] bprder-[0.6px] w-[100%]"></div>

        <div class="grid grid-cols-3 gap-4">
          <div>
            <p className="font-outfit  font-[500] text-[8px] leading-[10.08px]">
              Powered By <span className="text-[#2F80ED]">{productName}</span>{" "}
              <span className="text-[#007FFF] ">{productEdition}</span>
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default GrcStructure;
